import { useState, useEffect } from "react";
// redux
import { useSelector } from "react-redux";
// hooks
import usePageParams from "../../hooks/usePageParams";
// mui
import { Stack, Box } from "@mui/material";
// axios
import EnhancedAxios from "../../axios/EnhancedAxios";
import { AxiosResponse, AxiosError } from "axios";
// components
import {
    PageTitle,
    SortBox,
    SearchBox,
    PaginationFilter,
    LabelCard,
    LinkButton,
    ThreeDotsLoader,
    StatusFilterBox,
} from "../../components";
// icons
import { MdAdd } from "react-icons/md";
// alerts
import { errorAlert } from "../../utils/alerts/alerts";
// types
import { ReduxUserReducerState } from "../../types/global";

const Categories = () => {
    const userToken = useSelector(
        (state: ReduxUserReducerState) => state.user.userToken
    );
    const { page, setPage } = usePageParams();
    const [sortValue, setSortValue] = useState<string>("-created_at");
    const [searchValue, setSearchValue] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(24);
    const [totalItems, setTotalItems] = useState(24);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [categories, setCategories] = useState([]);
    const [dataChanged, setDataChanged] = useState(false);
    const [filterValues, setFilterValues] = useState<Record<string, string>>({
        status: "",
    });
    const items_cats_parent_id = process.env.REACT_APP_ITEMS_CATS_PARENT_ID;
    useEffect(() => {
        EnhancedAxios(null, userToken)
            .get(
                `/admin/categories?sorts=${sortValue}&page=${page}&paginate=${itemsPerPage}&filters=parent_id:${items_cats_parent_id},${filterValues.status}`
            )
            .then((res: AxiosResponse) => {
                setCategories(res.data.data);
                setTotalItems(res.data.meta.total);
                setLoading(false);
            })
            .catch((error: AxiosError) => {
                errorAlert(error);
            });
    }, [page, itemsPerPage, sortValue, dataChanged, filterValues]);
    return (
        <Stack gap="20px">
            <PageTitle title="ادراة التصنيفات" />
            <Stack>
                <LinkButton
                    text="اضافة تصنيف"
                    to={`/add-category/${process.env.REACT_APP_ITEMS_CATS_PARENT_ID}`}
                    icon={<MdAdd />}
                />
            </Stack>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap="10px"
                flexWrap="wrap"
            >
                <SearchBox
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                />
                <SortBox sortValue={sortValue} setSortValue={setSortValue} />
                <StatusFilterBox
                    filterValues={filterValues}
                    setFilterValues={setFilterValues}
                />
            </Box>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap="20px"
                flexWrap="wrap"
            >
                {loading ? (
                    <ThreeDotsLoader />
                ) : categories.length === 0 ? (
                    <p>لا توجد عناصر لعرضها</p>
                ) : (
                    categories.map((cat: any) => (
                        <LabelCard
                            key={cat.id}
                            label={cat.name}
                            id={cat.id}
                            editPagePath={`/edit-category/${cat.id}`}
                            endpointPath={`/admin/categories/${cat.id}`}
                            is_disabled={cat.is_disabled}
                            setDataChanged={setDataChanged}
                        />
                    ))
                )}
            </Box>
            <PaginationFilter
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                currentPage={page}
                setCurrentPage={setPage}
            />
        </Stack>
    );
};

export default Categories;
